import {css} from "styled-components";

export const BaseLinkStyles = css`
	border-radius: 4px;
	background: transparent;
	appearance: none;
	outline: none;
	display: block;
	padding: 0 15px;
	background-clip: padding-box;
	font-weight: 700;
	margin: 0;
	cursor: pointer;
	font-size: 16px;
	width: 100%;
	transition: all 0.2s linear;
	border: 1px solid;
	height: 44px;
	font-family: "Khand", sans-serif;
`;
